module.exports = __webpack_public_path__ + "static/img/culturePic3.3e06d1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/culturePic3.jpg
// module id = Nktr
// module chunks = 0